import React, { createContext, useContext, useEffect, useState, useMemo } from "react";
import { translations } from "../lib/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "cz";
    const saved = window.localStorage.getItem("lang");
    if (saved && translations[saved]) return saved;
    const browser = (navigator.language || "cz").slice(0, 2).toLowerCase();
    if (browser === "en") return "en";
    if (browser === "de") return "de";
    return "cz";
  });

  useEffect(() => {
    window.localStorage.setItem("lang", lang);
    document.documentElement.lang = lang === "cz" ? "cs" : lang;
  }, [lang]);

  const value = useMemo(
    () => ({ lang, setLang, t: translations[lang] }),
    [lang]
  );

  return (
    <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
};
